import React from "react";
import { Navigate, useParams } from "react-router-dom";

import {
  CHATBOT_CONTENT_MESSAGE_TYPE,
  decodeChatbotContentId,
  getChatbotContentDetailsPath,
} from "../../../utils/portalAluno/chatbotContentLink";
import { SHARED_CONTENT_PARAM } from "../../../utils/portalAluno/sharedContentLink";

const ChatbotContentRedirect = () => {
  const { encodedContentId = "" } = useParams<{
    encodedContentId: string;
  }>();
  const contentId = decodeChatbotContentId(encodedContentId);
  const isEmbedded = window.parent !== window;

  React.useEffect(() => {
    if (!isEmbedded || !contentId) return;

    window.parent.postMessage(
      {
        type: CHATBOT_CONTENT_MESSAGE_TYPE,
        contentId,
      },
      "*"
    );
  }, [contentId, isEmbedded]);

  if (isEmbedded) return null;
  if (!contentId) return <Navigate replace to="/app/chatbot" />;

  // Fora do iframe o link veio de um compartilhamento: o parâmetro de
  // compartilhamento preserva o destino durante o login e habilita a mensagem
  // de conteúdo indisponível.
  return (
    <Navigate
      replace
      to={`${getChatbotContentDetailsPath(contentId)}?${SHARED_CONTENT_PARAM}=1`}
      state={{ contentType: "conteudos" }}
    />
  );
};

export default ChatbotContentRedirect;
